export const NINETY_DAYS_IN_MS: number = 7776000000;

export const STATUS_CODE = {
	FORBIDDEN: 403
};

export const LIST_ENTITY_NAMES = {
	USERS: 'users',
	ROLES: 'roles',
	GAMEPLAY: 'gamePlay',
	TRANSACTIONHISTORY: 'transactionHistory',
	REFERRALS: 'referrals',
	PREVIOUSTICKETS: 'previousTickets',
	GAMEPLAY_TIMELINE: 'gameplayTimeline',
	ANALYZE_COLLUSION: 'analyzeCollusion',
	COUPONS: 'coupons',
	TOURNAMENT_LIST: 'tournamentList',
	CG_TOURNAMENT_LIST: 'cgTournamentList',
	MT_TOURNAMENT_LIST: 'mtTournamentList',
	OPPONENTS_DETAILS: 'opponentsDetails',
	BULK_REFUND: 'bulkRefund',
	USER_DEPOSITS: 'userDeposits',
	USER_WITHDRAWALS: 'userWithdrawals',
	FORM60_DETAILS: 'form60Details',
	PAYIN_DETAILS: 'payInDetails',
	KYC_BANK_NAME_MISMATCH: 'kycBankNameMismatch',
	BANK_AND_UPI_DETAILS: 'bankAndUpiDetails',
	CONFISCATION_AND_REFUND: 'confiscationAndRefund',
	MESSAGE_CENTER: 'messageCenter',
	INVOICE_GENERATION: 'invoiceGeneration',
	BULK_REPLY: 'bulkReply',
	KYC_DETAILS: 'kycDetails',
	REFUND_REQUEST: 'refundRequest',
	VPA_DETAILS: 'vpaDetails',
	BANK_DETAILS: 'bankDetails',
	KIND_REWARDS: 'kindRewards',
	OPPONENTS_GAME_DETAILS: 'opponentsGameDetails',
	PERMISSIONS: 'permissions',
	PERMISSIONS_SET: 'permissionsSet',
	BULK_PERMISSIONS: 'bulkPermissions',
	LEGAL_DETAILS: 'legalDetails'
};

export const ENTITY_GROUP = {
	USER_DETAILS: 'userDetails',
	WALLET: 'wallet',
	GAMEPLAY: 'gameplay',
	PAYMENT: 'payment',
	REWARD: 'reward',
	BULK_ACTIONS: 'bulkActions'
} as const;

export type EntityGroup = typeof ENTITY_GROUP[keyof typeof ENTITY_GROUP];

export const ENTITY = {
	USER_SUMMARY: 'userSummary',
	USER_SUMMARY_BLOCKED_UNBLOCKED: 'userSummaryBlockedUnblocked',
	USER_SUMMARY_FRAUD_STATUS: 'userSummaryFraudStatus',
	ACCOUNT_DETAILS: 'accountDetails',
	KYC_DETAILS: 'kycDetails',
	HELPDESK: 'helpdesk',
	REFERRALS: 'referrals',
	WALLET_DETAILS: 'walletDetails',
	TRANSACTION_PDF: 'transactionPdf',
	TOURNAMENTS: 'tournaments',
	TRANSACTION: 'transaction',
	COUPONS: 'coupons',
	OPPONENTS_DETAILS: 'opponentsDetails',
	BULK_REFUND: 'BULK_REFUND',
	BULK_REPLY: 'bulkReply',
	ANALYZE_COLLUSION: 'analyzeCollusion',
	REFUND_SUGGESTION: 'refundSuggestion'
} as const;

export type Entity = typeof ENTITY[keyof typeof ENTITY];

export const ACTION = {
	getBankAccountNameMismatchRejectionsByUid: 'getBankAccountNameMismatchRejectionsByUid',
	overrideBankNameMismatchKyc: 'overrideBankNameMismatchKyc',
	getUsers: 'getUsers',
	getUserSignUpAndLastActivity: 'getUserSignUpAndLastActivity',
	getUserSignUpAndLastActivityV2: 'getUserSignUpAndLastActivityV2',
	getWalletDetails: 'getWalletDetails',
	getUserPortfolio: 'getUserPortfolio',
	getUserNetPortfolio: 'getUserNetPortfolio',
	getUsersHeartBeatDetailsBulk: 'getUsersHeartBeatDetailsBulk',
	getUserCallingSlots: 'getUserCallingSlots',
	getBankDetails: 'getBankDetails',
	getRegisteredTournaments: 'getRegisteredTournaments',
	analyzeTournament: 'analyzeTournament',
	getNetworkLogsFromAthena: 'getNetworkLogsFromAthena',
	getKycDetails: 'getKycDetails',
	listHelpdeskTickets: 'listHelpdeskTickets',
	getReferralsSummary: 'getReferralsSummary',
	getTransactionDetails: 'getTransactionDetails',
	getCoupons: 'getCoupons',
	getActiveCouponForUser: 'getActiveCouponForUser',
	getCouponTnC: 'getCouponTnC',
	getUserOpponentDetails: 'getUserOpponentDetails',
	getPaymentStatus: 'getPaymentStatus',
	executeBulkRefund: 'executeBulkRefund',
	executeBulkRefundV2: 'executeBulkRefundV2',
	createBulkRefund: 'createBulkRefund',
	listBulkRefund: 'listBulkRefund',
	updateUserLevel: 'updateUserLevel',
	userSupportCall: 'userSupportCall',
	getUserDeposits: 'getUserDeposits',
	getUserWithdrawals: 'getUserWithdrawals',
	getForm60Details: 'getForm60Details',
	submitForm60Details: 'submitForm60Details',
	analyzeCollusion: 'analyzeCollusion',
	refundSuggestion: 'refundSuggestion',
	listBulkReply: 'listBulkReply',
	executeBulkReply: 'executeBulkReply',
	listKycDocumentsHistory: 'listKycDocumentsHistory',
	unsetBankAccount: 'unsetBankAccount',
	unsetUpiId: 'unsetUpiId',
	getTransactionPdf: 'getTransactionPdf',
	getTdsDetails: 'getTdsDetails',
	updateMessageCenterCard: 'updateMessageCenterCard',
	createMessageCenterCard: 'createMessageCenterCard',
	getAllCardsForMessageCenter: 'getAllCardsForMessageCenter',
	blockUnblockUser: 'blockUnblockUser',
	updateUserFraudStatus: 'updateUserFraudStatus',
	refundTournament: 'refundTournament',
	createTournamentRefundRequest: 'createTournamentRefundRequest',
	activatePayoutRecord: 'activatePayoutRecord',
	getRazorpayPayoutDetails: 'getRazorpayPayoutDetails',
	updateConfiscationAndRefundRequest: 'updateConfiscationAndRefundRequest',
	createConfiscationAndRefundRequest: 'createConfiscationAndRefundRequest',
	generateInvoice: 'generateInvoice',
	creditKindRewards: 'creditKindRewards',
	approveAndRefundTournamentInBulk: 'approveAndRefundTournamentInBulk',
	getBulkRefundCsvDetails: 'getBulkRefundCsvDetails',
	addBulkRefundCsvDetails: 'addBulkRefundCsvDetails',
	uploadBulkRefundCsv: 'uploadBulkRefundCsv',
	bulkRefundFromCsv: 'bulkRefundFromCsv',
	bulkRefundFromCsvV2: 'bulkRefundFromCsvV2',
	getGameplayTimeline: 'getGameplayTimeline',
	getOpponentsGameDetails: 'getOpponentsGameDetails',
	getPayoutRecords: 'getPayoutRecords',
	viewPayoutRecords: 'viewPayoutRecords',
	getUserDepositsAdmin: 'getUserDepositsAdmin',
	getUserWithdrawalsAdmin: 'getUserWithdrawalsAdmin',
	updateKYCStatus: 'updateKYCStatus',
	manuallyLinkPan: 'manuallyLinkPan',
	getKycDocs: 'getKycDocs',
	submitKyc: 'submitKyc',
	getKycSignedUrl: 'getKycSignedUrl',
	getBasicUserDetails: 'getBasicUserDetails',
	getTournamentRefundRequestInBulk: 'getTournamentRefundRequestInBulk',
	getConfiscationAndRefundRequestInBulk: 'getConfiscationAndRefundRequestInBulk',
	fetchBulkInvoice: 'fetchBulkInvoice',
	fetchUserKindReward: 'fetchUserKindReward',
	downloadUserPayoutDetails: 'downloadUserPayoutDetails',
	viewDOB: 'viewDOB',
	getLegalDetailsOfUser: 'getLegalDetailsOfUser',
	viewPhone: 'viewPhone',
	viewEmail: 'viewEmail',
	listSuspiciousTransactionsRequests: 'listSuspiciousTransactionsRequests',
	createSuspiciousTransactionsRequest: 'createSuspiciousTransactionsRequest',
	searchDpdpaUser: 'searchDpdpaUser',
	fetchDpdpaUserData: 'fetchDpdpaUserData',
	exportDpdpaUserData: 'exportDpdpaUserData',
	updateAlternatePhoneNumber: 'updateAlternatePhoneNumber',
	cancelSubscription: 'cancelSubscription'
} as const;

export type Action = typeof ACTION[keyof typeof ACTION];

export const ENTITY_GROUP_ENTITY_ACTION_MAP: {
	[entityGroup in EntityGroup]: {
		[entity: string]: { read: Array<Action>; write?: Array<Action>; maker?: Array<Action>; checker?: Array<Action> };
	};
} = {
	[ENTITY_GROUP.USER_DETAILS]: {
		[ENTITY.USER_SUMMARY]: {
			read: [
				ACTION.getUsers,
				ACTION.getUserSignUpAndLastActivity,
				ACTION.getUserSignUpAndLastActivityV2,
				ACTION.getUserPortfolio,
				ACTION.getUserNetPortfolio,
				ACTION.getUsersHeartBeatDetailsBulk,
				ACTION.getUserCallingSlots,
				ACTION.getUserOpponentDetails
			],
			write: [ACTION.updateUserLevel]
		},
		[ENTITY.USER_SUMMARY_BLOCKED_UNBLOCKED]: {
			read: [],
			write: [ACTION.blockUnblockUser]
		},
		[ENTITY.USER_SUMMARY_FRAUD_STATUS]: {
			read: [],
			write: [ACTION.updateUserFraudStatus]
		},
		[ENTITY.ACCOUNT_DETAILS]: {
			read: [ACTION.getBankDetails],
			write: [ACTION.unsetBankAccount, ACTION.unsetUpiId]
		},
		[ENTITY.KYC_DETAILS]: {
			read: [ACTION.getKycDetails, ACTION.getForm60Details, ACTION.listKycDocumentsHistory],
			write: [ACTION.submitForm60Details]
		},
		[ENTITY.HELPDESK]: {
			read: [ACTION.listHelpdeskTickets],
			write: [ACTION.userSupportCall]
		},
		[ENTITY.REFERRALS]: {
			read: [ACTION.getReferralsSummary],
			write: []
		}
	},
	[ENTITY_GROUP.WALLET]: {
		[ENTITY.WALLET_DETAILS]: {
			read: [ACTION.getWalletDetails, ACTION.getTdsDetails],
			write: []
		},
		[ENTITY.TRANSACTION_PDF]: {
			read: [],
			write: [ACTION.getTransactionPdf]
		}
	},
	[ENTITY_GROUP.GAMEPLAY]: {
		[ENTITY.TOURNAMENTS]: {
			read: [
				ACTION.getRegisteredTournaments,
				ACTION.analyzeTournament,
				ACTION.getNetworkLogsFromAthena,
				ACTION.analyzeCollusion
			],
			write: []
		},
		[ENTITY.ANALYZE_COLLUSION]: {
			read: [ACTION.analyzeCollusion],
			write: []
		},
		[ENTITY.REFUND_SUGGESTION]: {
			read: [ACTION.refundSuggestion],
			write: []
		}
	},
	[ENTITY_GROUP.PAYMENT]: {
		[ENTITY.TRANSACTION]: {
			read: [ACTION.getTransactionDetails, ACTION.getPaymentStatus, ACTION.getUserDeposits, ACTION.getUserWithdrawals],
			write: []
		}
	},
	[ENTITY_GROUP.REWARD]: {
		[ENTITY.COUPONS]: {
			read: [ACTION.getActiveCouponForUser, ACTION.getCoupons, ACTION.getCouponTnC],
			write: []
		}
	},
	[ENTITY_GROUP.BULK_ACTIONS]: {
		[ENTITY.BULK_REFUND]: {
			read: [ACTION.listBulkRefund],
			write: [ACTION.createBulkRefund, ACTION.executeBulkRefund, ACTION.executeBulkRefundV2]
		},
		[ENTITY.BULK_REPLY]: {
			read: [ACTION.listBulkReply],
			write: [ACTION.executeBulkReply]
		}
	}
};

export const SETTINGS_ENTITY = {
	USER: 'user',
	ROLE: 'role'
} as const;

export type SettingsEntity = typeof SETTINGS_ENTITY[keyof typeof SETTINGS_ENTITY];

export const SETTINGS_ACTION = {
	login: 'login',
	createUser: 'createUser',
	editUser: 'editUser',
	listUsers: 'listUsers',
	getRoles: 'getRoles',
	updateRole: 'updateRole',
	createRole: 'createRole'
} as const;

export type SettingsAction = typeof SETTINGS_ACTION[keyof typeof SETTINGS_ACTION];

export const SETTINGS_ENTITY_ACTION_MAP = {
	[SETTINGS_ENTITY.USER]: {
		read: [SETTINGS_ACTION.login, SETTINGS_ACTION.listUsers],
		write: [SETTINGS_ACTION.createUser, SETTINGS_ACTION.editUser]
	},
	[SETTINGS_ENTITY.ROLE]: {
		read: [SETTINGS_ACTION.getRoles],
		write: [SETTINGS_ACTION.createRole, SETTINGS_ACTION.updateRole]
	}
};

export const MISCELLANEOUS_ENTITY = {
	CONFISCATION_AND_REFUND: 'confiscationAndRefund',
	MESSAGE_CENTER: 'messageCenter',
	INVOICE_GENERATION: 'invoiceGeneration',
	REFUND_REQUEST: 'refundRequest',
	KIND_REWARDS: 'kindRewards',
	SUSPICIOUS_TRANSACTIONS: 'suspiciousTransactions',
	DPDPA_DATA_ACCESS: 'dpdpaDataAccess'
} as const;

export type MiscellaneousEntity = typeof MISCELLANEOUS_ENTITY[keyof typeof MISCELLANEOUS_ENTITY];

export const MISCELLANEOUS_ACTION = {
	getConfiscationAndRefundRequestInBulk: 'getConfiscationAndRefundRequestInBulk',
	createConfiscationAndRefundRequest: 'createConfiscationAndRefundRequest',
	updateConfiscationAndRefundRequest: 'updateConfiscationAndRefundRequest',
	createConfiscationAndRefundRequestInBulk: 'createConfiscationAndRefundRequestInBulk',
	getLegalDetailsOfUser: 'getLegalDetailsOfUser'
} as const;

export const MISCELLANEOUS_ENTITY_ACTION_MAP = {
	[MISCELLANEOUS_ENTITY.CONFISCATION_AND_REFUND]: {
		read: [MISCELLANEOUS_ACTION.getConfiscationAndRefundRequestInBulk],
		maker: [MISCELLANEOUS_ACTION.createConfiscationAndRefundRequest],
		checker: [
			MISCELLANEOUS_ACTION.updateConfiscationAndRefundRequest,
			MISCELLANEOUS_ACTION.createConfiscationAndRefundRequestInBulk
		]
	}
};

export const BULK_REFUNDS_ENTITY_ACTION_MAP = {};

type Resources = {
	[key: string]: string;
};

type Scopes = { [key: string]: { [key: string]: string } };

export const PAGE_NAMES: { [key: string]: string } = {
	settings: 'settings',
	settingsV2: 'settingsV2',
	userProfile: 'userProfile',
	gamePlay: 'gamePlay',
	bulkActions: 'bulkActions',
	paymentsStatus: 'paymentsStatus',
	miscellaneous: 'miscellaneous',
	permissionsManagement: 'permissionsManagement'
};

export const RESOURCES: { [key: string]: string } = {
	basicDetails: 'basicDetails',
	gameplay: 'gameplay',
	transactionHistory: 'transactionHistory',
	kycDetails: 'kycDetails',
	previousTickets: 'previousTickets',
	referrals: 'referrals',
	userStats: 'userStats',
	coupons: 'coupons',
	user: 'user',
	role: 'role'
};

export const PAGE_RESOURCE_MAP = {
	[PAGE_NAMES.settings]: {
		user: 'user',
		role: 'role'
	},
	[PAGE_NAMES.userProfile]: {
		basicDetails: 'basicDetails',
		gameplay: 'gameplay',
		transactionHistory: 'transactionHistory',
		kycDetails: 'kycDetails',
		previousTickets: 'previousTickets',
		referrals: 'referrals',
		userStats: 'userStats',
		coupons: 'coupons',
		kycBankNameMismatch: 'kycBankNameMismatch'
	},
	[PAGE_NAMES.bulkActions]: {
		bulkRefund: 'bulkRefund',
		allCoupons: 'allCoupons',
		payInDetails: 'payInDetails',
		bulkReply: 'bulkReply'
	},
	[PAGE_NAMES.paymentsStatus]: {
		userDeposits: 'userDeposits',
		userWithdrawals: 'userWithdrawals'
	},
	[PAGE_NAMES.miscellaneous]: {
		confiscationAndRefund: 'confiscationAndRefund',
		messageCenter: 'messageCenter',
		invoiceGeneration: 'invoiceGeneration',
		refundRequest: 'refundRequest',
		kindRewards: 'kindRewards',
		legalDetails: 'legalDetails',
		dpdpaDataAccess: 'dpdpaDataAccess'
	}
};

export const USER_PROFILE_RESOURCES: Resources = {
	basicDetails: 'basicDetails',
	gameplay: 'gameplay',
	transactionHistory: 'transactionHistory',
	kycDetails: 'kycDetails',
	previousTickets: 'previousTickets',
	referrals: 'referrals',
	userStats: 'userStats',
	coupons: 'coupons',
	// tournaments: 'tournaments',
	paymentsStatus: 'paymentsStatus',
	lotteryWinnings: 'lotteryWinnings',
	kycBankNameMismatch: 'kycBankNameMismatch'
};

export const USER_PAYMENTS_STATUS_RESOURCES = {
	userDeposits: 'userDeposits',
	userWithdrawals: 'userWithdrawals'
};

export const SETTINGS_RESOURCES: Resources = {
	user: 'user',
	role: 'role'
};

export const BULK_ACTIONS_RESOURCES: Resources = {
	bulkRefund: 'bulkRefund',
	allCoupons: 'allCoupons',
	payInDetails: 'payInDetails',
	bulkReply: 'bulkReply'
};

export const ACL_RESOURCES: Resources = {
	bulkRefundV2: 'bulkRefundV2'
};

export const MISCELLANEOUS_RESOURCES: Resources = {
	confiscationAndRefund: 'confiscationAndRefund',
	messageCenter: 'messageCenter',
	invoiceGeneration: 'invoiceGeneration',
	refundRequest: 'refundRequest',
	kindRewards: 'kindRewards',
	legalDetails: 'legalDetails',
	suspiciousTransactions: 'suspiciousTransactions',
	dpdpaDataAccess: 'dpdpaDataAccess'
};

export const RESOURCE_ENTITY_MAP = {
	[SETTINGS_RESOURCES.user]: [{ entityGroup: 'settings', entity: 'user' }],
	[SETTINGS_RESOURCES.role]: [{ entityGroup: 'settings', entity: 'role' }],

	[USER_PROFILE_RESOURCES.basicDetails]: [
		{ entityGroup: ENTITY_GROUP.USER_DETAILS, entity: ENTITY.USER_SUMMARY },
		{ entityGroup: ENTITY_GROUP.USER_DETAILS, entity: ENTITY.USER_SUMMARY_BLOCKED_UNBLOCKED },
		{ entityGroup: ENTITY_GROUP.USER_DETAILS, entity: ENTITY.USER_SUMMARY_FRAUD_STATUS },
		{ entityGroup: ENTITY_GROUP.USER_DETAILS, entity: ENTITY.ACCOUNT_DETAILS },
		{ entityGroup: ENTITY_GROUP.WALLET, entity: ENTITY.WALLET_DETAILS }
	],
	[USER_PROFILE_RESOURCES.gameplay]: [
		{ entityGroup: ENTITY_GROUP.GAMEPLAY, entity: ENTITY.TOURNAMENTS },
		{ entityGroup: ENTITY_GROUP.GAMEPLAY, entity: ENTITY.ANALYZE_COLLUSION },
		{ entityGroup: ENTITY_GROUP.GAMEPLAY, entity: ENTITY.REFUND_SUGGESTION }
	],
	[USER_PROFILE_RESOURCES.transactionHistory]: [{ entityGroup: ENTITY_GROUP.PAYMENT, entity: ENTITY.TRANSACTION }],
	[USER_PROFILE_RESOURCES.kycDetails]: [{ entityGroup: ENTITY_GROUP.USER_DETAILS, entity: ENTITY.KYC_DETAILS }],
	[USER_PROFILE_RESOURCES.previousTickets]: [{ entityGroup: ENTITY_GROUP.USER_DETAILS, entity: ENTITY.HELPDESK }],
	[USER_PROFILE_RESOURCES.referrals]: [{ entityGroup: ENTITY_GROUP.USER_DETAILS, entity: ENTITY.REFERRALS }],
	[USER_PROFILE_RESOURCES.userStats]: [{ entityGroup: ENTITY_GROUP.USER_DETAILS, entity: ENTITY.USER_SUMMARY }],
	[USER_PROFILE_RESOURCES.coupons]: [{ entityGroup: ENTITY_GROUP.REWARD, entity: ENTITY.COUPONS }],
	[USER_PROFILE_RESOURCES.tournaments]: [{ entityGroup: ENTITY_GROUP.GAMEPLAY, entity: ENTITY.TOURNAMENTS }],
	[BULK_ACTIONS_RESOURCES.bulkRefund]: [{ entityGroup: ENTITY_GROUP.BULK_ACTIONS, entity: ENTITY.BULK_REFUND }],
	[BULK_ACTIONS_RESOURCES.bulkReply]: [{ entityGroup: ENTITY_GROUP.BULK_ACTIONS, entity: ENTITY.BULK_REPLY }],
	[BULK_ACTIONS_RESOURCES.allCoupons]: [{ entityGroup: ENTITY_GROUP.REWARD, entity: ENTITY.COUPONS }],
	[BULK_ACTIONS_RESOURCES.payInDetails]: [{ entityGroup: ENTITY_GROUP.PAYMENT, entity: ENTITY.TRANSACTION }],
	[USER_PROFILE_RESOURCES.paymentsStatus]: [{ entityGroup: ENTITY_GROUP.PAYMENT, entity: ENTITY.TRANSACTION }],
	[USER_PAYMENTS_STATUS_RESOURCES.userDeposits]: [{ entityGroup: ENTITY_GROUP.PAYMENT, entity: ENTITY.TRANSACTION }],
	[USER_PAYMENTS_STATUS_RESOURCES.userWithdrawals]: [{ entityGroup: ENTITY_GROUP.PAYMENT, entity: ENTITY.TRANSACTION }],
	[MISCELLANEOUS_RESOURCES.confiscationAndRefund]: [{ entityGroup: 'miscellaneous', entity: 'confiscationAndRefund' }],
	[MISCELLANEOUS_RESOURCES.messageCenter]: [{ entityGroup: 'miscellaneous', entity: 'messageCenter' }],
	[MISCELLANEOUS_RESOURCES.invoiceGeneration]: [{ entityGroup: 'miscellaneous', entity: 'invoiceGeneration' }],
	[MISCELLANEOUS_RESOURCES.refundRequest]: [{ entityGroup: 'miscellaneous', entity: 'refundRequest' }],
	[MISCELLANEOUS_RESOURCES.kindRewards]: [{ entityGroup: 'miscellaneous', entity: 'kindRewards' }],
	[MISCELLANEOUS_RESOURCES.legalDetails]: [{ entityGroup: 'miscellaneous', entity: 'legalDetails' }],
	[MISCELLANEOUS_RESOURCES.suspiciousTransactions]: [{ entityGroup: 'miscellaneous', entity: 'suspiciousTransactions' }],
	[MISCELLANEOUS_RESOURCES.dpdpaDataAccess]: [{ entityGroup: 'miscellaneous', entity: 'dpdpaDataAccess' }]
};

export const SETTINGS_SCOPES: Scopes = {
	[SETTINGS_RESOURCES.user]: {
		login: 'login',
		createUser: 'createUser',
		editUser: 'editUser',
		listUsers: 'listUsers'
	},
	[SETTINGS_RESOURCES.role]: {
		getRoles: 'getRoles',
		updateRole: 'updateRole',
		createRole: 'createRole'
	}
};

export const BULK_ACTIONS_SCOPES = {
	[BULK_ACTIONS_RESOURCES.bulkRefund]: {
		executeBulkRefund: 'executeBulkRefund',
		executeBulkRefundV2: 'executeBulkRefundV2',
		listBulkRefund: 'listBulkRefund',
		createBulkRefund: 'createBulkRefund'
	},
	[BULK_ACTIONS_RESOURCES.allCoupons]: {
		getCoupons: 'getCoupons',
		getCouponTnC: 'getCouponTnC'
	},
	[BULK_ACTIONS_RESOURCES.payInDetails]: {
		getPaymentStatus: 'getPaymentStatus'
	},
	[BULK_ACTIONS_RESOURCES.bulkReply]: {
		executeBulkReply: 'executeBulkReply',
		listBulkReply: 'listBulkReply'
	}
};

export const MISCELLANEOUS_SCOPES = {
	[MISCELLANEOUS_RESOURCES.confiscationAndRefund]: {
		getConfiscationAndRefundRequestInBulk: 'getConfiscationAndRefundRequestInBulk',
		createConfiscationAndRefundRequest: 'createConfiscationAndRefundRequest',
		updateConfiscationAndRefundRequest: 'updateConfiscationAndRefundRequest',
		createConfiscationAndRefundRequestInBulk: 'createConfiscationAndRefundRequestInBulk'
	},
	[MISCELLANEOUS_RESOURCES.messageCenter]: {
		getAllCardsForMessageCenter: 'getAllCardsForMessageCenter',
		createMessageCenterCard: 'createMessageCenterCard',
		getMessageCenterCardCategories: 'getMessageCenterCardCategories',
		updateMessageCenterCard: 'updateMessageCenterCard'
	},
	[MISCELLANEOUS_RESOURCES.legalDetails]: {
		getLegalDetailsOfUser: 'getLegalDetailsOfUser'
	},
	[MISCELLANEOUS_RESOURCES.suspiciousTransactions]: {
		listSuspiciousTransactionsRequests: 'listSuspiciousTransactionsRequests',
		createSuspiciousTransactionsRequest: 'createSuspiciousTransactionsRequest',
		checkSuspiciousTransactionsRequestStatus: 'checkSuspiciousTransactionsRequestStatus'
	},
	[MISCELLANEOUS_RESOURCES.dpdpaDataAccess]: {
		searchDpdpaUser: 'searchDpdpaUser',
		fetchDpdpaUserData: 'fetchDpdpaUserData',
		exportDpdpaUserData: 'exportDpdpaUserData'
	}
};

export const PERMISSION_LEVEL = {
	READ: 'read',
	WRITE: 'write',
	MASKED: 'masked',
	NONE: undefined
} as const;

export type PermissionLevel = typeof PERMISSION_LEVEL[keyof typeof PERMISSION_LEVEL];

export const MISCELLANEOUS_PERMISSION_LEVEL = {
	READ: 'read',
	MAKER: 'maker',
	CHECKER: 'checker',
	NONE: undefined
} as const;

export type MiscellaneousPermissionLevel = typeof MISCELLANEOUS_PERMISSION_LEVEL[keyof typeof MISCELLANEOUS_PERMISSION_LEVEL];

export interface RoleDocument {
	_id?: string;
	role: string;
	roleActions: RoleActions;
}
export interface User {
	_id?: string;
	userName: string;
	email: string;
	roleId: string;
	isDisabled: boolean;
	role?: string;
}
export interface AccessTokenResponse {
	success?: boolean;
	error?: string;
	accessToken?: string;
	validity?: number;
}
export interface EntityGroupActions {
	[entity: string]: PermissionLevel;
}

export interface MiscellaneousEntityGroupActions {
	[entity: string]: MiscellaneousPermissionLevel;
}

export interface AppActions {
	[entityGroup: string]: PermissionLevel | EntityGroupActions;
}

export interface CRMActions {
	[appName: string]: PermissionLevel | AppActions;
}

export interface RoleActions {
	app: PermissionLevel | CRMActions;
	settings: PermissionLevel | EntityGroupActions;
	miscellaneous: MiscellaneousPermissionLevel | MiscellaneousEntityGroupActions;
}

export const USER_PROFILE_ACL_ACTIONS = {
	callUser: 'callUser',
	createHelpdeskTicket: 'createHelpdeskTicket',
	activatePayoutRecord: 'activatePayoutRecord'
};
